import {
    CardContainer,
    Title,
    Description,
    Points,
    PointsWrapper,
} from '../styles';

interface IProps {
    title: string;
    description: string;
    points: string[];
    order: number;
}

const Card = (props: IProps) => {
    const { title, description, points, order } = props;

    return (
        <CardContainer order={order}>
            <Title>{title}</Title>
            <Description>{description}</Description>
            <PointsWrapper>
                <ul
                    style={{
                        margin: 'unset',
                        marginLeft: '20px',
                        padding: 'unset',
                    }}
                >
                    {points.map((point: string, i: number) => (
                        <Points key={i}>{point}</Points>
                    ))}
                </ul>
            </PointsWrapper>
        </CardContainer>
    );
};

export default Card;
